import _ from 'lodash';

import {Component, Module} from 'app/decorators';
import BlndTable from 'app/common/table';
import CompanyIdPicker from 'app/directives/company-id.picker';
import ProductPicker from 'app/directives/product.picker';
import SecureUrlService from 'app/services/secure.url';
import {PrinterListModalCtrl} from 'app/printers/ctrls';

import StatusButtonComponent from 'app/directives/status.button/component';

import {stateFilters} from '../constants';

import printModalTpl from 'app/printers/modal.list.html';
import tpl from './list.html';


@Module({
    name: "app.tickets.components.list",
    modules: [
        CompanyIdPicker,
        ProductPicker,
        SecureUrlService,
        StatusButtonComponent,
    ],
})
@Component({
    selector: 'ticket-list',
    bindings: {
        customer: '=?',
        extraFields: '<',
    },
    template: tpl,
})
export default class C {
    constructor ($scope, $state, $element, $growl, $stateParams, $timeout, R, Modal, SecureUrlService, TicketStore, NgTableParams) {
        "ngInject";
        let self = this;
        self.stateFilters = stateFilters;

        self.$scope = $scope;
        self.$growl = $growl;
        self.$element = $element;
        self.$stateParams = $stateParams;
        self.$state = $state;
        self.$timeout = $timeout;
        self.secureUrlService = SecureUrlService;
        self.Modal = Modal;
        self.R = R;
        self.defaultParams = {
            search: '',
            status: 'open',
            created_at__range: '',
            ordering: ['-created_at'],
            page_size: 20,
            contains_product: null,
        };
        self.selectedObjects = [];
        if (self.customer) {
            self.defaultParams.customer = self.customer.id;
        }

        this.resetParams();
        this.applyQSParams();
        this.table = new BlndTable(
            NgTableParams, TicketStore,
            {
                defaultParams: this.defaultParams,
                params: this.params,
                onChange: (params) => this.onChange(params)
            }
        );
        this.watcher = null;
    }

    $onInit () {
        let self = this;

        self.canPrint = true;
        self.companies = {};

        self.watcher = self.$scope.$watch(() => self.table.checked, function() {
            let tickets = self.table.store.list;
            let checked = self.table.checked;

            self.companies = {};
            self.selectedObjects = self.table.getSelectedObjects();
            _.each(_.range(0, _.keys(checked).length), function (index) {
                let ticket = tickets[index];
                if (ticket && checked[ticket.id]) {
                    self.companies[ticket.company.id] = true;
                }
            });
            self.canPrint = _.keys(self.companies).length <= 1;  // As we need to select printer for company
            self.table.updateAllChecked();
        }, true);
    }

    $onDestroy () {
        if (this.watcher) {
            this.watcher();
        }
        this.table.onDestroy();
        delete this.table;
        this.$element.remove();
        this.$element = null;
    }

    printChemicals (preview=true) {
        let self = this;
        let selectedTicket = self.table.getSelected();

        if (preview) {
            self.secureUrlService.openInNewWindow(self.R.all('chemicals'), {id: selectedTicket});
        } else {
            self.print(selectedTicket);
        }
    }

    print (object) {
        let self = this;
        let $modal = this.Modal.open({
            template: printModalTpl,
            controller: PrinterListModalCtrl,
            size: 'large',
            resolve: {
                company: () => _.first(_.keys(self.companies)),
                request: () => {
                    return {
                        endpoint: self.R.all('chemicals').all('print'),
                        params: {id: object},
                        multiple: false
                    }
                },
            }
        });

        $modal.result.then(function(){
            self.$growl.success('Added file to queue');
        });
    }

    applyQSParams () {
        let params = {};
        for (let k of Object.keys(this.$stateParams)) {
            let v = this.$stateParams[k];
            if (!_.isUndefined(v)) {
                params[k] = v;
            }
        }

        params.company = parseInt(params.company) || undefined;
        params.contains_product = parseInt(params.contains_product) || null;
        delete params.customerId;
        _.extend(this.params, params);
    }

    onChange (params_) {
        // clear current params:
        let params = {};
        for (let [k, v] of Object.entries(this.$state.$current.params)) {
            if (v.location === 'search') {
                params[k] = undefined;
            }
        }

        params = _.extend(params, params_);
        params.page = parseInt(params.page) || undefined;

        this.$state.go('.', params, {notify: false});
    }

    resetParams () {
        this.params = _.clone(this.defaultParams);
        this.selectedContainsProduct = null;
        this.searchMode = 'ticket';
        this.searchModeLabel = 'Ticket';
    }

    setSearchMode (mode) {
        const labels = {ticket: 'Ticket', product: 'Product'};
        this.searchMode = mode;
        this.searchModeLabel = labels[mode];
        if (mode === 'ticket') {
            this.selectedContainsProduct = null;
            this.params.contains_product = null;
            this.$timeout(() => {
                const input = this.$element[0].querySelector('.ticket-search-input-wrapper input[type="text"]');
                if (input) input.focus();
            });
        } else {
            this.params.search = '';
            this.$timeout(() => {
                const toggle = this.$element[0].querySelector('.ticket-list-page-product-picker .ui-select-toggle');
                if (toggle) toggle.click();
            });
        }
        this.refresh();
    }

    onContainsProductChange () {
        this.params.contains_product = this.selectedContainsProduct
            ? this.selectedContainsProduct.id
            : null;
        this.refresh();
    }

    refresh () {
        return this.table.refresh(this.params);
    }

}



// WEBPACK FOOTER //
// ./src/app/tickets/components/list.js